<template>
  <div class="mx-4">
    <StudentProfileHeader class="mb-6" :student="student" />
    <StudentProfileMain class="mb-6" :student="student" />
    <div class="text-center" v-if="$auth.policies['delete-student']">
      <v-btn class="mb-4" @click="remove" color="red" outlined>Xóa Học viên</v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import StudentProfileHeader from './StudentProfileHeader'
import StudentProfileMain from './StudentProfileMain'

export default {
  components: {
    StudentProfileHeader,
    StudentProfileMain
  },
  props: {
    student: Object
  },
  methods: {
    ...mapActions('student', ['removeStudent']),
    remove() {
      this.$dialog.confirm({
        title: 'Xóa Học Sinh',
        text: `Bạn có chắc muốn xóa học viên này.?`,
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeStudent(this.student)
          this.$router.push(`/students/`)
        }
      })
    }
  }
}
</script>
